export default __webpack_public_path__ + "static/media/apple-juice@2x.03e07689.png";